wbApp.directive('wbOnlinePaymentConfigurationCombo', ['$timeout', '$translate', '$filter', 'onlinePaymentConfigurationSvc',
    function ($timeout, $translate, $filter, onlinePaymentConfigurationSvc) {

        function getProviderTypeStr(providerType) {
            switch (providerType) {
                // case 0:
                //     return 'Payeezy (Fio)';
                case 1:
                    return 'Comgate';
                case 2:
                    return 'GP webpay';
                default:
                    return 'UNKNOWN';
            }
        }

        function formatResult(config) {
            if (!config) { return; }

            return "<div class='row' style='width:400px'>" +
                        "<div class='col-md-7'>" + config.name + "</div>" +
                        "<div class='col-md-5'>" + getProviderTypeStr(config.providerType) + "</div>" +
                   "</div>";
        }


        function formatSelection(config) {
            return config.name + ' [' + getProviderTypeStr(config.providerType) + ']';
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            link: function (scope, elm, attrs, ctrl) {

                var configs = onlinePaymentConfigurationSvc.getAllAsync();

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_ONLINE_PAYMENT_CONFIGURATION'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        data: configs,
                        id: function (config) { return config.id; }
                    });

                    ctrl.$render();
                });

                ctrl.$render = function () {
                    configs.$promise.then(function () {
                        $(elm).select2('val', ctrl.$viewValue);
                    });
                }

                elm.on('change', function (e) {
                    scope.$apply(function () {
                        ctrl.$setViewValue(e.val);                        
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });

            }
        }
    }]);